import React from "react";

const HomePageNewsSkeleton: React.FC = () => {
  return (
    <div className="p-9 pt-0 max-md:px-0">
      <div className="flex items-center justify-center max-sm:flex-wrap max-sm:gap-3">
        <div className="skeleton w-[300px] h-[440px] !rounded-none"></div>
        <div className="skeleton w-[300px] h-[440px] !rounded-none"></div>
      </div>
      <div className="skeleton w-80 h-12 ms-auto mt-10 py-4 px-9"></div>
    </div>
  );
};

export default HomePageNewsSkeleton;
